import { msalInstance, getSilentRequest } from "@/msalConfig";
/**
 * MSAL のアクセストークンを取得して fetch 実行。
 * 有効期限が10分未満なら forceRefresh で更新。
 * 401 の場合は 1 度だけ強制更新してリトライ。
 */
export async function authFetch(input, init = {}, options = {}) {
	const { forceRefreshOnFirst = false } = options;
	// 内部関数：トークン取得＋fetch 実行
	const doFetch = async (forceRefresh = false) => {
		const req = getSilentRequest();
		let res = await msalInstance.acquireTokenSilent({ ...req, forceRefresh });
		// 有効期限チェック（10分未満なら強制更新）
		const expiresOn = res.expiresOn?.getTime() || 0;
		const remainingMs = expiresOn - Date.now();
		// console.log(remainingMs / 1000 / 60);
		if (!forceRefresh && remainingMs < 10 * 60 * 1000) {
			res = await msalInstance.acquireTokenSilent({ ...req, forceRefresh: true });
		}
		// Authorization ヘッダー付与
		const headers = new Headers(init.headers || {});
		headers.set("Authorization", `Bearer ${res.accessToken}`);
		return fetch(input, { ...init, headers });
	};
	// 1回目：オプションで強制更新可能
	let response = await doFetch(forceRefreshOnFirst);
	// 401 の場合だけ 1 度だけ強制更新してリトライ
	if (response.status === 401) {
		response = await doFetch(true);
	}
	return response;
}
